import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { Card } from "../onboarding/adminUi";
import { btn } from "../leads/PriorityBadge";
import { AssignmentRow } from "./AssignmentRow";

const FILTERS = [["", "Todos"], ["pending", "Pendientes"], ["overdue", "Fecha pasada"], ["needs_review", "Necesitan revisión"], ["completed", "Completados"], ["needs_setup", "Ficha incompleta"], ["retired", "Retirados"]];

export const AssignTab = ({ library, clients }) => {
  const [cid, setCid] = useState("");
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState([]);
  const [due, setDue] = useState(new Date().toLocaleDateString("sv-SE"));
  const [repeat, setRepeat] = useState("");
  const [filter, setFilter] = useState("");
  const load = useCallback(() => (cid ? api.get(`/admin/test-assignments?client_id=${cid}`).then((r) => setRows(r.data)).catch((e) => toast.error(formatErr(e))) : setRows([])), [cid]);
  useEffect(() => { load(); setSel([]); }, [load]);
  const activeIds = new Set(rows.filter((r) => r.status === "active").map((r) => r.template_id));
  const assign = () => api.post("/admin/test-assignments", { client_id: cid, template_ids: sel, due_date: due, repeat_every_days: repeat ? Number(repeat) : null })
    .then((r) => { toast.success(`${r.data.created.length} test(s) asignado(s)`); setSel([]); load(); }).catch((e) => toast.error(formatErr(e)));
  const shown = rows.filter((r) => !filter || r.state === filter);
  return (
    <div data-testid="ta-tab">
      <select className="qv-input" value={cid} onChange={(e) => setCid(e.target.value)} style={{ maxWidth: 360, marginBottom: 14 }} data-testid="ta-client">
        <option value="">— Elige un futbolista —</option>
        {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      {cid && (<>
        <Card title="Asignar tests" testid="ta-assign-card">
          <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 8 }}>Selecciona uno o varios tests de tu biblioteca. Solo tú decides qué hace cada futbolista.</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 6, marginBottom: 12 }}>
            {library.filter((t) => !t.archived).map((t) => {
              const on = sel.includes(t.id); const dis = activeIds.has(t.id);
              return (
                <label key={t.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, padding: 6, border: `1px solid ${on ? "#dc2626" : "rgba(255,255,255,0.08)"}`, opacity: dis ? 0.5 : 1, cursor: dis ? "default" : "pointer" }} data-testid={`ta-pick-${t.id}`}>
                  <input type="checkbox" disabled={dis} checked={on} onChange={() => setSel(on ? sel.filter((x) => x !== t.id) : [...sel, t.id])} />
                  <span>{t.label || t.name}{dis ? " · ya asignado" : ""}{t.setup_issues?.length ? <span style={{ color: "#f97316" }}> · ficha incompleta</span> : ""}</span>
                </label>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
            <label style={{ fontSize: 12, color: "#a3a3a3" }}>Fecha de evaluación<input type="date" className="qv-input" value={due} onChange={(e) => setDue(e.target.value)} data-testid="ta-due" /></label>
            <label style={{ fontSize: 12, color: "#a3a3a3" }}>Repetir cada (días; vacío = frecuencia de la ficha)<input type="number" min="1" className="qv-input" value={repeat} onChange={(e) => setRepeat(e.target.value)} data-testid="ta-repeat" /></label>
            <button style={btn("#dc2626")} disabled={!sel.length} onClick={assign} data-testid="ta-assign"><Plus size={14} /> Asignar {sel.length || ""}</button>
          </div>
        </Card>
        <Card title={`Tests de este futbolista · ${rows.filter((r) => r.status === "active").length} activos`} testid="ta-list-card">
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
            {FILTERS.map(([k, l]) => <button key={k} style={{ ...btn(filter === k ? "#dc2626" : "transparent"), padding: "4px 10px", fontSize: 12 }} onClick={() => setFilter(k)} data-testid={`ta-filter-${k || "all"}`}>{l} ({k ? rows.filter((r) => r.state === k).length : rows.length})</button>)}
          </div>
          {shown.length === 0 ? <div style={{ fontSize: 13, color: "#a3a3a3" }}>Sin tests en este estado.</div> : shown.map((a) => <AssignmentRow key={a.id} a={a} reload={load} />)}
        </Card>
      </>)}
    </div>
  );
};
